import React, { useState } from 'react'

import type { LinkViewModel } from '../../view-models/LinkViewModel'
import Button from '../_legacy/Button'
import Dropdown from '../Dropdown/Dropdown'
import DropdownLinks from '../DropdownLinks/DropdownLinks'
import styles from './pageLogin-style.css'
import cx from 'classnames'
import { HighlightCardViewModel } from '@/view-models/HighlightCardViewModel'

type Props = {
  loggedIn?: boolean
  title?: string
  items?: Array<LinkViewModel>
  align?: 'right' | 'left'
  cardLinks?: Array<HighlightCardViewModel>
  text?: string
  onDropdownLinksUpdate ?: (links: React.ReactNode, title: string) => void
}

const LoggedInContent: React.FC<{
  loggedIn?: boolean
  title?: string
  items?: Array<LinkViewModel>
  align: 'right' | 'left'
  cardLinks?: Array<HighlightCardViewModel>
  text?: string
  onDropdownLinksUpdate ?: (links: React.ReactNode, title: string) => void
}> = ({ loggedIn, title, items, align, cardLinks, text, onDropdownLinksUpdate }) => {
  const eventMeta = {
    event: 'menu-login',
  }

  const [dropdownVisible, setDropdownVisible] = useState(false)

  if (!items) return null

  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev)
    if (onDropdownLinksUpdate) {
      const dropdownLinks = (
        <DropdownLinks
          items={items}
          className={styles.pageLoginDropdown}
          eventName="login"
          text={text}
          cardLinks={cardLinks}
        />
      )
      onDropdownLinksUpdate(dropdownLinks, title || '')
    }
  }

  if (loggedIn) {
    return (
      <Button {...items?.[0]} className={styles.button}>
        {title}
      </Button>
    )
  }

  return (
    <div>
      <Button
        className={styles.button}
        onClick={toggleDropdown}
        eventMeta={dropdownVisible ? {} : { event: 'menu-login' }}
      >
        {title}
      </Button>
    </div>
  )
}

const PageLogin: React.FC<Props> = ({ loggedIn, title, items, align = 'right', cardLinks, text, onDropdownLinksUpdate }) => {
  if (!items) return null

  return (
    <div className={styles.pageLogin}>
      <LoggedInContent
        loggedIn={loggedIn}
        title={title}
        items={items}
        align={align}
        cardLinks={cardLinks}
        text={text}
        onDropdownLinksUpdate={onDropdownLinksUpdate}
      />
    </div>
  )
}

export default PageLogin
